import { render, staticRenderFns } from "./Bivar.vue?vue&type=template&id=13267628&scoped=true&"
import script from "./Bivar.vue?vue&type=script&lang=js&"
export * from "./Bivar.vue?vue&type=script&lang=js&"
import style0 from "./Bivar.vue?vue&type=style&index=0&id=13267628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13267628",
  null
  
)

export default component.exports